import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { StoreProvider } from './context/StoreContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { ChatbotWidget } from './components/ChatbotWidget';
import { HomePage } from './pages/HomePage';
import { ProductsPage } from './pages/ProductsPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { WishlistPage } from './pages/WishlistPage';
import { LoginPage } from './pages/LoginPage';
import { MyOrdersPage } from './pages/MyOrdersPage';
import { OrderTrackingPage } from './pages/OrderTrackingPage';
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminLayout } from './pages/admin/AdminLayout';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminProducts } from './pages/admin/AdminProducts';
import { AdminOrders } from './pages/admin/AdminOrders';
import { AdminPromoCodes } from './pages/admin/AdminPromoCodes';
import { AdminSettings } from './pages/admin/AdminSettings';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function CustomerLayout() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-1 pb-20 md:pb-0" data-id="element-2">
        <Outlet data-id="element-3" />
      </main>
      <Footer data-id="element-4" />
      <WhatsAppButton data-id="element-5" />
      <ChatbotWidget data-id="element-6" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-7">
      <StoreProvider data-id="element-8">
        <ScrollToTop data-id="element-9" />
        <Routes data-id="element-10">
          {/* Customer Routes */}
          <Route element={<CustomerLayout data-id="element-12" />} data-id="element-11">
            <Route path="/" element={<HomePage data-id="element-14" />} data-id="element-13" />
            <Route path="/products" element={<ProductsPage data-id="element-16" />} data-id="element-15" />
            <Route path="/product/:id" element={<ProductDetailPage data-id="element-18" />} data-id="element-17" />
            <Route path="/cart" element={<CartPage data-id="element-20" />} data-id="element-19" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-22" />} data-id="element-21" />
            <Route path="/wishlist" element={<WishlistPage data-id="element-24" />} data-id="element-23" />
            <Route path="/login" element={<LoginPage data-id="element-26" />} data-id="element-25" />
            <Route path="/my-orders" element={<MyOrdersPage data-id="element-28" />} data-id="element-27" />
            <Route path="/order/:id" element={<OrderTrackingPage data-id="element-30" />} data-id="element-29" />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin data-id="element-32" />} data-id="element-31" />
          <Route path="/admin" element={<AdminLayout data-id="element-34" />} data-id="element-33">
            <Route path="dashboard" element={<AdminDashboard data-id="element-36" />} data-id="element-35" />
            <Route path="products" element={<AdminProducts data-id="element-38" />} data-id="element-37" />
            <Route path="orders" element={<AdminOrders data-id="element-40" />} data-id="element-39" />
            <Route path="promos" element={<AdminPromoCodes data-id="element-42" />} data-id="element-41" />
            <Route path="settings" element={<AdminSettings data-id="element-44" />} data-id="element-43" />
          </Route>
        </Routes>
      </StoreProvider>
    </BrowserRouter>;
}